import { IconButton, TextField, Tooltip } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { useCameraModes } from "@features/camera/modes";
import { FaceSmileIcon, MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import { motion } from "framer-motion";

type CategoryType = "pack" | "tryon" | "haircut" | "image";

type TemplatesToolbarProps = {
  activeCategory: CategoryType;
  setActiveCategory: (category: CategoryType) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

export const TemplatesToolbar = ({
  activeCategory,
  setActiveCategory,
  searchQuery,
  setSearchQuery,
}: TemplatesToolbarProps) => {
  const { t } = useTranslation();
  const { modes } = useCameraModes();

  return (
    <motion.div
      className="px-4"
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      <div className="flex gap-2 items-center">
        {modes.pack && (
          <Tooltip content={t("camera.form.modes.pack")}>
            <IconButton
              size="3"
              color="purple"
              className="mx-0 shrink-0"
              variant={activeCategory === "pack" ? "solid" : "soft"}
              onClick={() => setActiveCategory("pack")}
            >
              <modes.pack.icon className="h-4 w-4" />
            </IconButton>
          </Tooltip>
        )}
        {modes.tryon && (
          <Tooltip content={t("camera.form.modes.tryon")}>
            <IconButton
              size="3"
              color="brown"
              className="mx-0 shrink-0"
              variant={activeCategory === "tryon" ? "solid" : "soft"}
              onClick={() => setActiveCategory("tryon")}
            >
              <modes.tryon.icon className="h-4 w-4" />
            </IconButton>
          </Tooltip>
        )}
        {modes.haircut && (
          <Tooltip content={t("camera.form.modes.haircut")}>
            <IconButton
              size="3"
              color="orange"
              className="mx-0 shrink-0"
              variant={activeCategory === "haircut" ? "solid" : "soft"}
              onClick={() => setActiveCategory("haircut")}
            >
              <modes.haircut.icon className="h-4 w-4" />
            </IconButton>
          </Tooltip>
        )}
        {modes.image && (
          <Tooltip content="Memes">
            <IconButton
              size="3"
              color="green"
              className="mx-0 shrink-0"
              variant={activeCategory === "image" ? "solid" : "soft"}
              onClick={() => setActiveCategory("image")}
            >
              <FaceSmileIcon className="h-4 w-4" />
            </IconButton>
          </Tooltip>
        )}

        <TextField.Root
          size="3"
          className="flex-1 min-w-0"
          placeholder={t("components.search.placeholder")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        >
          <TextField.Slot>
            <MagnifyingGlassIcon className="h-4 w-4" />
          </TextField.Slot>
        </TextField.Root>
      </div>
    </motion.div>
  );
};
